import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

// The "botón enorme" CTA block from the brief.
export default function BookCTA({ dark = true }) {
  return (
    <section
      className={`${dark ? "bg-[#2A2C29] text-[#f9f8f6]" : "bg-[#efece5] text-[#1a1a1a]"}`}
      data-testid="book-cta-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-40 text-center">
        <Reveal>
          <p className={`overline mb-8 ${dark ? "text-white/40" : ""}`}>
            Primer paso
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <Link
            to="/agenda"
            data-testid="book-cta-link"
            className="group inline-block"
          >
            <span className="font-display text-4xl sm:text-6xl md:text-7xl lg:text-[7rem] leading-[0.95] tracking-tight">
              Agendar una
              <br />
              <span className="italic">primera entrevista</span>
            </span>
            <span
              className={`mt-8 flex items-center justify-center gap-3 text-sm tracking-wide ${
                dark ? "text-white/70" : "text-[#5c5c5c]"
              }`}
            >
              Ver horarios disponibles
              <ArrowRight
                size={18}
                className="transition-transform duration-300 group-hover:translate-x-1.5 text-[#9C5A4B]"
              />
            </span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
